document.addEventListener('DOMContentLoaded', () => {
  const mobileOpenButton = document.querySelector('[mobile-open-button]')
  const mobileCloseButton = document.querySelector('[mobile-close-button]')
  const mobileMenu = document.querySelector('[mobile-menu]')

  mobileOpenButton?.addEventListener('click', () => {
    mobileMenu?.classList.add('is-open')
    document.body.classList.toggle('overflow-hidden')
  })

  mobileCloseButton?.addEventListener('click', () => {
    mobileMenu?.classList.remove('is-open')
    document.body.classList.remove('overflow-hidden')
  })
})